import HashtagList from "./hashtag-list";

export default HashtagList;